var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('router-view'),(_vm.isIntranet && _vm.computeToTopVisible)?_c('ToTop'):(!_vm.isIntranet)?_c('ToTopNew',{attrs:{"isIntranet":false}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }